import type {
    AdminServiceFixedPriceComponent,
    AdminServicePriceComponent,
    AdminServiceUsagePriceComponent,
    NormalizeAdminServicePriceComponentFromApiParams,
} from '../types';
import normalizeAdminServiceUsageRateFromApi from './normalizeAdminServiceUsageRateFromApi';
import throwUnsupportedAdminServiceBilling from './throwUnsupportedAdminServiceBilling';

const normalizeAdminServicePriceComponentFromApi = ({
    component,
}: NormalizeAdminServicePriceComponentFromApiParams): AdminServicePriceComponent => {
    const priceComponent = component as {
        kind?: unknown;
    } & Partial<AdminServiceFixedPriceComponent> &
        Partial<AdminServiceUsagePriceComponent>;

    if (priceComponent.kind === 'fixed') {
        const fixedComponent = component as AdminServiceFixedPriceComponent;
        if (
            fixedComponent.cadence !== 'one_time' &&
            fixedComponent.cadence !== 'monthly' &&
            fixedComponent.cadence !== 'yearly'
        ) {
            return throwUnsupportedAdminServiceBilling({
                message: `Unsupported service billing from API: fixed cadence ${String(
                    fixedComponent.cadence
                )}`,
            });
        }

        return {
            id: fixedComponent.id,
            kind: 'fixed',
            name: fixedComponent.name,
            amountCents: fixedComponent.amountCents,
            cadence: fixedComponent.cadence,
        };
    }

    if (priceComponent.kind === 'usage') {
        const usageComponent = component as AdminServiceUsagePriceComponent;
        if (usageComponent.cadence !== 'monthly' && usageComponent.cadence !== 'yearly') {
            return throwUnsupportedAdminServiceBilling({
                message: `Unsupported service billing from API: usage cadence ${String(
                    usageComponent.cadence
                )}`,
            });
        }

        return {
            id: usageComponent.id,
            kind: 'usage',
            name: usageComponent.name,
            meterId: usageComponent.meterId,
            cadence: usageComponent.cadence,
            rate: normalizeAdminServiceUsageRateFromApi({ rate: usageComponent.rate }),
        };
    }

    return throwUnsupportedAdminServiceBilling({
        message: `Unsupported service billing from API: component kind ${String(
            priceComponent.kind
        )}`,
    });
};

export default normalizeAdminServicePriceComponentFromApi;
